import React, { ReactNode } from 'react'
import {} from 'react-router-dom'

// Layout import
import Layout from '@/components/Layout'

export interface routerType {
  path: string
  component: ReactNode
  children?: routerType[]
}

export const ignorePath = ['']
export const ignoreAuthPath = ['/board', '/']

// {{ AURA-X: Modify - 添加类型断言解决Emotion JSX与React 19类型冲突. Approval: 寸止(ID:1730070000). }}
const router: routerType[] = [
  {
    path: '/',
    component: (<Layout />) as ReactNode,
    children: [
      {
        path: '/',
        component: '../pages/home/index.tsx'
      },
      {
        path: '/board',
        component: '../pages/board/index.tsx'
      },
      {
        path: '/layout',
        component: '../pages/layout/index.tsx'
      },
      {
        path: '/local-redraw',
        component: '../pages/local-redraw/index.tsx'
      },
      {
        path: '/board-new',
        component: '../pages/board-new/index.tsx'
      },
      {
        path: '*',
        component: '../pages/home/index.tsx'
      }
    ]
  }
]

export default router
